export default "__VITE_ASSET__xspjmnno__"